import React from 'react';
import { Box, List } from '@mui/material';
import { ProcessingStep } from '../types';
import { ProcessingStepItem } from './ProcessingStepItem';
import { ThinkingSection } from './ThinkingSection';
import { DocumentProcessingSection } from './DocumentProcessingSection';
import { ErrorSection } from './ErrorSection';

interface ProcessingStepsTabProps {
  steps: ProcessingStep[];
  showThinking: boolean;
  thinkingText: string;
  showDocumentProcessing: boolean;
  documentProcessingText: string;
  currentProcessingPhase: string;
  error: string;
}

export const ProcessingStepsTab: React.FC<ProcessingStepsTabProps> = ({
  steps,
  showThinking,
  thinkingText,
  showDocumentProcessing,
  documentProcessingText,
  currentProcessingPhase,
  error,
}) => {
  return (
    <Box sx={{ p: 3 }}>
      {/* Processing Steps */}
      <List sx={{ py: 0 }}>
        {steps.map((step, index) => (
          <ProcessingStepItem 
            key={step.id} 
            step={step} 
            index={index} 
          />
        ))}
      </List>

      {/* Document Processing Section */}
      <DocumentProcessingSection 
        showDocumentProcessing={showDocumentProcessing} 
        documentProcessingText={documentProcessingText}
        currentProcessingPhase={currentProcessingPhase}
      />

      {/* Thinking Section */}
      <ThinkingSection 
        showThinking={showThinking} 
        thinkingText={thinkingText} 
      />

      {/* Error Section (bottom of steps tab) */}
      <ErrorSection error={error} />
    </Box>
  );
}; 